import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({

  /* ===== Base (≥1441) ===== */
  sectionPadding: { boxSizing: 'border-box' },

  banner: {
    height: 86,
    border: '1px solid #EEE',
    borderRadius: 8,
    // background: 'linear-gradient(90deg, #F8F9FF 24.76%, #F4F6FF 100%)',
    overflow: 'hidden',
    position: 'relative',
    padding: '24px 135px',
    boxSizing: 'border-box',
  },
  bannerImg: {
    height: 82,
    width: 82,
    position: 'absolute',
    transform: 'rotate(-10.26deg)',
    bottom: -7,
    left: 25,
  },
  bannerRow: { display: 'flex', gap: 12 },
  bannerBtn: {
    height: 36,
    width: 140,
    padding: 12,
    backgroundColor: 'transparent',
    borderRadius: 4,
    border: '1px solid #3F51B5',
    color: '#3F51B5',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': { backgroundColor: 'transparent', borderColor: '#3F51B5', boxShadow: 'none' },
  },
  bannerTextWrap: { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 },
  bannerSubHeading: {
    fontSize: 12, fontWeight: 400, lineHeight: '17px', color: 'rgba(69, 70, 83, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%',
  },
  bannerTopHeading: {
    fontSize: 12, fontWeight: 400, lineHeight: '17px', color: 'rgba(146, 147, 166, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%',
  },

  tableSection: {
    padding: '24px 24px 24px 24px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  tableTitle: {
    fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(43, 44, 53, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
  }
}));

export default useStyles;
